export const SEVERITY_LEVEL_MAPPING = {
  5: ['urgent'],
  4: ['critical'],
  3: ['major', 'high'],
  2: ['moderate', 'medium'],
  1: ['minor', 'low'],
};

export const SEVERITY_LEVEL_COLOR_MAPPING = {
  5: '#ff4500', // urgent,
  4: '#ff0000', // critical
  3: '#ffa500', // major, high
  2: '#ffff00', // moderate, medium
  1: '#008000', // low,
};